export const REFUND_STATUS_INITIATED = 'initiated';
export const REFUND_STATUS_RECEIVED = 'received';
export const REFUND_STATUS_FINISHED = 'finished';
export const REFUND_STATUS_ADVANCED = 'advanced';
export const REFUND_STATUS_CANCELLED = 'cancelled';
export const REFUND_STATUS_RETURN_TO_CLIENT = 'returned';
